import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ConfirmationNumberIcon(props: IconProps) {
    return <Icon {...props} iconKey={"confirmation_number"}/>
}
